import { AexNgToolboxModule } from '@aex/ngx-toolbox';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DateInputsModule, DateTimePickerModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FilterModule } from '@progress/kendo-angular-filter';
import { GridModule, EditService } from '@progress/kendo-angular-grid';
import { IconsModule, SVGIconModule } from '@progress/kendo-angular-icons';
import { CheckBoxModule, FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { FloatingLabelModule, LabelModule } from '@progress/kendo-angular-label';
import { CardModule, DrawerModule, LayoutModule } from '@progress/kendo-angular-layout';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import 'hammerjs';
import { AdvanceSearchGridComponent } from './advance-search-grid/advance-search-grid.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DateRangeSelectorComponent } from './date-range-selector/date-range-selector.component';
import { DateValueRowComponent } from './date-value-row/date-value-row.component';
import { DrawerComponent } from './drawer/drawer.component';
import { FieldValueRowComponent } from './field-value-row/field-value-row.component';
import { GridStateViewComponent } from './grid-state-view/grid-state-view.component';
import { LabelButtonRowComponent } from './label-button-row/label-button-row.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { SearchGridComponent } from './search-grid/search-grid.component';
import { TimeValueRowComponent } from './time-value-row/time-value-row.component';
import {CommonLibModule} from "@aex/shared/common-lib";

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    RouterModule,
    AexNgToolboxModule.forChild(),
    TextBoxModule,
    TooltipModule,
    ButtonModule,
    ButtonsModule,
    BreadCrumbModule,
    CardModule,
    ChartsModule,
    CheckBoxModule,
    DateInputsModule,
    DateTimePickerModule,
    DialogModule,
    DropDownsModule,
    DropDownListModule,
    FilterModule,
    FloatingLabelModule,
    FormFieldModule,
    GridModule,
    IconsModule,
    SVGIconModule,
    LabelModule,
    LayoutModule,
    DrawerModule,
    LoaderModule,
    CommonLibModule,
  ],
	providers: [
		EditService,
	],
	declarations: [
		AdvanceSearchGridComponent,
		BreadcrumbComponent,
		DateRangeSelectorComponent,
		FieldValueRowComponent,
		GridStateViewComponent,
		SearchGridComponent,
		DateValueRowComponent,
		TimeValueRowComponent,
		LabelButtonRowComponent,
		PieChartComponent,
		DrawerComponent,
	],
	exports: [
		AdvanceSearchGridComponent,
		BreadcrumbComponent,
		DateRangeSelectorComponent,
		FieldValueRowComponent,
		GridStateViewComponent,
		SearchGridComponent,
		DateValueRowComponent,
		TimeValueRowComponent,
		LabelButtonRowComponent,
		PieChartComponent,
		DrawerComponent,
	],
})
export class SharedUiComponentsModule {
}
